import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/default.module.scss';

const propTypes = {
    color: PropTypes.string,
    muted: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    muted: false,
    className: null,
};

const VolumeIcon = ({ color, muted, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="36px"
        height="11px"
        viewBox="0 0 36 11"
        enableBackground="new 0 0 36 11"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <rect
            x="0.5"
            y="8.5"
            fill={!muted ? color : 'transparent'}
            stroke={color}
            strokeMiterlimit="10"
            width="5"
            height="2"
        />
        <rect
            x="8"
            y="6.5"
            fill={!muted ? color : 'transparent'}
            stroke={color}
            strokeMiterlimit="10"
            width="5"
            height="4"
        />
        <rect
            x="15.5"
            y="4.5"
            fill={!muted ? color : 'transparent'}
            stroke={color}
            strokeMiterlimit="10"
            width="5"
            height="6"
        />
        <rect
            x="23"
            y="2.5"
            fill={!muted ? color : 'transparent'}
            stroke={color}
            strokeMiterlimit="10"
            width="5"
            height="8"
        />
        <rect
            x="30.5"
            y="0.5"
            fill={!muted ? color : 'transparent'}
            stroke={color}
            strokeMiterlimit="10"
            width="5"
            height="10"
        />
    </svg>
);

VolumeIcon.propTypes = propTypes;
VolumeIcon.defaultProps = defaultProps;

export default VolumeIcon;
